import { Routes } from '@angular/router';
import { AdminTeamsLoadedGuard } from '@app/core/guards/admin-teams-loaded.guard';

export const ADMIN_ROUTES: Routes = [
    {
        path: 'dashboard',
        data: { section: 'ADMIN_DASHBOARD_SECTION' },
        loadChildren: () => import('@app/client/account/admin/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AdminTeamsLoadedGuard]
    },
    {
        path: 'transfers',
        pathMatch: 'prefix',
        loadChildren: () => import('@app/client/account/admin/transfers/transfers.module').then(m => m.TransfersModule),
        canActivate: [AdminTeamsLoadedGuard]
    },
    {
        path: 'billing',
        pathMatch: 'full',
        loadChildren: () => import('@app/client/account/admin/billing/billing.module').then(m => m.BillingModule),
    },
    {
        path: 'members',
        pathMatch: 'prefix',
        loadChildren: () => import('@app/client/account/admin/members/members.module').then(m => m.MembersModule),
        canActivate: [AdminTeamsLoadedGuard],
        data: { routeAdmin: true }
    },
    {
        path: 'guests',
        pathMatch: 'prefix',
        loadChildren: () => import('@app/client/account/admin/guests/guests.module').then(m => m.GuestsModule),
        canActivate: [AdminTeamsLoadedGuard]
    },
    {
        path: 'groups',
        pathMatch: 'prefix',
        loadChildren: () => import('@app/client/account/admin/groups/groups.module').then(m => m.GroupsModule),
        canActivate: [AdminTeamsLoadedGuard]
    },
    {
        path: 'teams',
        pathMatch: 'prefix',
        loadChildren: () => import('@app/client/account/admin/teams/teams.module').then(m => m.TeamsModule),
        canActivate: [AdminTeamsLoadedGuard]
    },
    {
        path: 'sso',
        pathMatch: 'full',
        loadChildren: () => import('@app/client/account/admin/sso/sso.module').then(m => m.SsoModule),
    },
    {
        path: 'provisioning',
        pathMatch: 'full',
        loadChildren: () => import('@app/client/account/admin/provisioning/provisioning.module').then(m => m.ProvisioningModule),
    },
    {
        path: 'security',
        pathMatch: 'full',
        loadChildren: () => import('@app/client/account/admin/security/security.module').then(m => m.SecurityModule),
    }
];
